<template>
    <div>
        <loading-custom :loading="loading" />
        <div v-if="status.order">
            <order-show-component
                :orderId="orderId"
                :shop="shop"
                @onClose="onOrderUpdate($event)"
            >
            </order-show-component>
        </div>
        <div v-else>
            <div class="row tw-flex-row tw-justify-end">
                <div class="col-lg-3 col-6 tw-self-end">
                    <div class="form-group">
                        <label class="tw-ml-2">เซลเพจ</label>
                        <select
                            name="salepage_id"
                            class="form-control"
                            v-model="search.salepage_id"
                            @change="filterData"
                        >
                            <option value="">--- เลือก sale page ---</option>
                            <option
                                v-for="(salepage, index) in salepages_data"
                                :key="index"
                                :value="salepage.id"
                            >
                                {{ salepage.title }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-3 col-6 tw-self-end">
                    <div class="form-group">
                        <label class="tw-ml-2">ค้นหา</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="search.name"
                            placeholder="ค้นหา"
                            @input="filterSearch()"
                        />
                    </div>
                </div>
                <div class="col-lg-3 col-6 tw-self-end">
                    <div class="form-group">
                        <label class="tw-ml-2">สถานะ</label>
                        <select
                            class="form-control"
                            v-model="search.status"
                            @change="filterData"
                        >
                            <option value="">ทั้งหมด</option>
                            <option value="pending">รอการตรวจสอบ</option>
                            <option value="cancel">ยกเลิก</option>
                            <option value="approve">รอส่ง</option>
                            <option value="done">ส่งแล้ว</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-hover mb-0 c_list">
                    <thead>
                        <tr>
                            <th class="">ลำดับ</th>
                            <th class="text-center">
                                ออเดอร์
                            </th>
                            <th class="text-center">
                                ผู้สั่งซื้อ
                            </th>
                            <th class="text-center">
                                สถานะ
                            </th>
                            <th class="text-center">ราคา</th>
                            <th class="text-center">เลขขนส่ง</th>
                            <th class="text-center">วันที่ทำรายการ</th>
                            <th class="text-center"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-if="
                                tableData.data
                                    ? tableData.data.length === 0
                                    : tableData.data
                            "
                        >
                            <td class="text-center" colspan="8">
                                ไม่พบข้อมูล
                            </td>
                        </tr>
                        <tr
                            v-for="(item, index) in tableData.data"
                            :key="index"
                        >
                            <td>
                                {{ index + 1 }}
                            </td>
                            <td class="text-center">
                                {{ item.reference }}
                            </td>
                            <td class="text-center">
                                <div>
                                    {{ item.name }}
                                </div>
                            </td>
                            <td class="text-center">
                                <div
                                    :class="
                                        `badge 
                                        ${
                                            item.status == 'pending'
                                                ? 'badge-warning'
                                                : ''
                                        }
                                        ${
                                            item.status == 'cancel'
                                                ? 'badge-danger'
                                                : ''
                                        }
                                        ${
                                            item.status == 'approve'
                                                ? 'badge-primary'
                                                : ''
                                        }
                                        ${
                                            item.status == 'done'
                                                ? 'badge-success'
                                                : ''
                                        }
                                        `
                                    "
                                >
                                    {{
                                        `${
                                            item.status == "pending"
                                                ? "รอการตรวจสอบ"
                                                : ""
                                        }
                                    ${item.status == "cancel" ? "ยกเลิก" : ""}
                                    ${item.status == "approve" ? "รอส่ง" : ""}
                                    ${item.status == "done" ? "ส่งแล้ว" : ""}
                                    `
                                    }}
                                </div>
                            </td>
                            <td class="text-center">
                                <div>
                                    {{ item.price_total }}
                                </div>
                            </td>
                            <td class="text-center">
                                <div>
                                    {{ item.tracking_number || "-" }}
                                </div>
                            </td>
                            <td class="text-center">
                                <div>
                                    {{ dateFormat(item.created_at) }}
                                </div>
                            </td>
                            <td>
                                <button
                                    type="button"
                                    data-type="confirm"
                                    class="btn btn-sm btn-primary"
                                    @click="showDetail(item)"
                                >
                                    <i class="fa fa-search"> </i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="tw-flex tw-mt-5  tw-justify-center lg:tw-justify-end">
                <paginate
                    :data="tableData"
                    :page="page"
                    @onPage="onPage($event)"
                    v-show="tableData.total > 0"
                ></paginate>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import paginate from "../../helper/Paginate.vue";
export default {
    props: ["shop", "salepages"],
    components: {
        paginate
    },
    data() {
        return {
            salepages_data: this.salepages,
            orderId: "",
            page: 1,
            loading: false,
            search: {
                name: "",
                status: "",
                salepage_id: ""
            },
            status: {
                order: false
            },
            tableData: {}
        };
    },
    mounted() {
        this.setSearchFilter();
    },
    methods: {
        queryOrder() {
            // this
            const { reference } = this.getQuery();
            if (reference) {
                const dataRef = _.find(this.tableData.data, item => {
                    return item.reference == reference;
                });
                this.showDetail(dataRef);
            }
        },
        onOrderUpdate(val) {
            if (val == "close") {
                this.status.order = false;
                this.orderId = "";
                this.filterData();
            }
        },
        onPage(page) {
            this.page = page;
            this.getData();
        },
        dateFormat(date) {
            return moment(date).format("DD/MM/YYYY h:mm:ss a") || "";
        },
        setSearchFilter() {
            const { name } = this.getQuery();
            this.search.name = name;
            if (!name) {
                this.getData();
            } else {
                this.filterData();
            }
        },
        getQuery() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            return params;
        },
        showDetail(item) {
            this.status.order = true;
            this.orderId = item.id;
        },
        filterSearch: _.debounce(function(e) {
            this.filterData();
        }, 1000),
        filterData() {
            let query = "";
            this.page = 1;
            Object.keys(this.search).forEach(element => {
                if (this.search[element] != "" && this.search[element]) {
                    query = `${query}&${element}=${this.search[element]}`;
                }
            });
            if (query != "?") {
                this.getData(query);
            } else {
                this.getData();
            }
        },
        async getData(query = "") {
            this.loading = true;
            await axios
                .get(
                    `/backend/s/${this.shop}/orders/report?page=${this.page}${query}`
                )
                .then(res => {
                    this.tableData = res.data.order;
                    this.queryOrder();
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
